<template lang="pug">
#report-summary.card-box
  .d-md-flex
    .p-2.mr-auto
      .m-b-10
        | ページまるごとWebP変換レポート
      h3.text-dark.site-title.m-t-m-b-30.d-flex
        span.align-self-center
          | {{summary.title}}
        span.align-self-center.m-l-5.badge.badge-danger(v-if="summary.webp && summary.webp.count > 0")
          | WebP導入済み

    .p-2.text-right
      .m-b-10
        DateTime(v-bind:dateTime="summary.time" locale="ja" v-if="summary.time")
      div
        MyVueGoodshare

  #report-summary-body.row.m-t-20
    .col-md-3.text-center
      Screenshot(v-bind:screenshotKey="summary.screenshot.s3Key")
      div
        span.badge.badge-dark
          template(v-if="summary.device == 'sp'")
            i.mdi.mdi-cellphone-iphone
            | スマートフォンサイト
          template(v-else)
            i.mdi.idi-laptop
            | PCサイト
        | &nbsp;
      div
        a(v-bind:href="summary.url") {{summary.url}}

    .col-md-9
      ReportReview(v-bind:summary="summary")
      h4.text-dark.header-title.m-t-30.text-center フォーマット別の削減率
      ImageSizeChart(v-bind:summary="summary")
</template>

<style lang="scss">
.site-title {
  font-weight: bold;
}
</style>

<script>
import Screenshot from '@/components/common/Screenshot'
import ResourceTypeChart from '@/components/chart/ResourceTypeChart'
import ImageSizeChart from '@/components/chart/ImageSizeChart'
import ReportReview from '@/components/ReportReview'
import MyVueGoodshare from "@/components/MyVueGoodshare"
import DateTime from '@/components/common/DateTime'

export default {
  components: {
    Screenshot,
    ResourceTypeChart,
    ImageSizeChart,
    ReportReview,
    MyVueGoodshare,
    DateTime,
  },
  props: {
    label: String,
    summary: Object,
  },
}
</script>